import React from "react";

function VehicleComplianceForm() {
  return (
    <>
      <style>
        {`
          /* CSS for print functionality */
          @media print {
            body * {
              visibility: hidden; /* Hide all elements on the page by default */
            }
            #VehicleComplianceForm, #VehicleComplianceForm * {
              visibility: visible; /* Make only the form and its children visible */
              color: initial !important; /* Revert to default text color */
              font-weight: initial !important; /* Revert to default font weight */
            }
            #VehicleComplianceForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide the print button when printing */
            .print-button {
              display: none;
            }
            /* Ensure input fields and textareas are visible and readable when printed */
            input, textarea {
                border: 1px solid #000 !important;
                background-color: transparent !important;
            }
          }
        `}
      </style>

      <div id="VehicleComplianceForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Vehicle Paperwork & Documentation Check</h3>

        <form>
          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="vehicleRegistration">
              Vehicle Registration:
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Checked By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="checkedBy">
              Checked By (Name):
            </label>
            <input
              type="text"
              id="checkedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="date">
              Date:
            </label>
            <input
              type="date"
              id="date"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* PMI Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="pmiDate">
              PMI Date:
            </label>
            <input
              type="date"
              id="pmiDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* MOT Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="motDate">
              MOT Date:
            </label>
            <input
              type="date"
              id="motDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Tax Expiry Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="taxExpiry">
              Tax Expiry Date:
            </label>
            <input
              type="date"
              id="taxExpiry"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Insurance Expiry Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="insuranceExpiry">
              Insurance Expiry Date:
            </label>
            <input
              type="date"
              id="insuranceExpiry"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* All in Order */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">All in Order:</label>
            <div className="space-x-4 flex flex-wrap">
              <label className="flex items-center space-x-1">
                <input type="radio" name="allInOrder" value="Yes" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="allInOrder" value="No" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>

          {/* Legally Compliant */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Is the vehicle Legally Compliant:</label>
            <div className="space-x-4 flex flex-wrap">
              <label className="flex items-center space-x-1">
                <input type="radio" name="legallyCompliant" value="Yes" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="legallyCompliant" value="No" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>

          {/* Relevant Documents */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">
              Are all relevant documents present and on the vehicle:
            </label>
            <div className="space-x-4 flex flex-wrap">
              <label className="flex items-center space-x-1">
                <input type="radio" name="documentsPresent" value="Yes" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="documentsPresent" value="No" className="form-radio text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>

          {/* Notes */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record any issues or actions required, such as renewals or missing documents"
            />
          </div>

          {/* Signatures */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managerSignature">
              Signature of Manager:
            </label>
            <input
              type="text"
              id="managerSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Manager Signature"
            />
          </div>

          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="TMSignature">
              Signature of Transport Manager:
            </label>
            <input
              type="text"
              id="TMSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Transport Manager Signature"
            />
          </div>
        </form>

        {/* Print Button */}
        <div className="mt-6 text-right print-button">
          <button
            type="button"
            onClick={() => window.print()}
            className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg"
          >
            Print Form
          </button>
        </div>
      </div>
    </>
  );
}

export default VehicleComplianceForm;

